import { Component, OnInit } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'app/shared/services/authenticationService';
import { BaseComponent } from 'app/shared/baseClasses/BaseComponent';
import { EventAggregator, EventList } from '../shared/utility/EventAggregator';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent extends BaseComponent implements OnInit {
  private code: string;
  private email: string;
  password: string;
  confirmPassword: string;

  customLogoUrl: any;
  logoLoading: any;

  constructor(
    private config: AppConfig,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) {
    super(config);
  }

  ngOnInit() {
    this.code = this.route.snapshot.queryParams['code'];
    this.email = this.route.snapshot.queryParams['email'];

  }

  getCustomLogo(data: any) {
    let imgExtension = data.fileName.split('.')[1];
    let newBlob = new Blob([data.result], { type: `image/${imgExtension}` });

  }

  submit() {
    if (this.password === this.confirmPassword) {
      this.authenticationService.emailResetPassword(
        this.code,
        this.email,
        this.password,
        this.confirmPassword
      );
    } else {
      EventAggregator.publish(EventList.popupTriggered, {
        type: 'alertMessage',
        value: { msg: 'The passwords do not match' }
      });
    }
  }
}
